module.exports = __webpack_public_path__ + "img/savings-what-is.a41032e.png";